import React from "react";
import { ErrorMessage, Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";

import { CustomButton, CustomDialog, CustomSelect, FeaturedIcon, FormikTextField } from "../../../components";
import css from "../../account-details/modals/modals.module.css";
import { useMutation } from "@tanstack/react-query";
import RebatesClient from "../../../RebatesClient";
import { useNavigate } from "react-router-dom";

const ModalFarmOrSubEnt = ({
  account,
  parent_account_id,
  canAddSubEntity,
  open,
  onClose,
}) => {

  const navigate = useNavigate();

  const account_types = [{ id: "SUB_ENTITY", value: "SUB_ENTITY", name: 'Sub Account' }, { id: "FARM", value: "FARM", name: 'Farm' }]

  const validationSchema = Yup.object({
    ...(!account?.id && canAddSubEntity ? { account_type: Yup.string().required('Account type is required').oneOf(account_types?.map(type => type.id), 'Account type is required') } : {}),
    name: Yup.string().required("Name is required"),
    // rewards_code: Yup.string().required("Rewards ID is required"),
  });



  const { mutateAsync: submitRequest, isLoading, } = useMutation({
    mutationKey: "saveFarmSubEnt",
    networkMode: "always",
    mutationFn: async (updatedData) => await RebatesClient.saveFarmOrSubEnt(updatedData, parent_account_id || account?.parent_account_id),
    onError: (err) => { console.log(err) },
    onSuccess: (resp) => {
      // console.log(resp)
      if (resp.response.status == 200) {
        if (account?.id) {
          // since the farm name may have changed navigate to the new url so it reloads with new name
          navigate(`/${formik.values.account_type == 'FARM' || account?.account_type === "FARM" ? 'farm' : 'sub-account'}/${encodeURIComponent(formik.values.name)}`,   { replace: account?.id? true : false });
        }
      
        close()
      }
      else {
        alert(`${resp.body.status}`)
      }

    }
  });
  // console.log(account)

  const formik = useFormik({
    initialValues: {
      id: account?.id, //this is null on new account creating
      parent_account_id: parent_account_id || account?.parent_account_id,
      name: account?.name || "",
      rewards_code: account?.rewards_code || "",
      account_type: !account?.account_type && !canAddSubEntity ? "FARM" : "-1" //"SUB_ENTITY"
    },

    validationSchema: validationSchema,
    onSubmit: submitRequest
  });

  function close() {
    formik.resetForm()
    onClose()
  }



  // console.log(formik.values.account_type)
  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon={account?.id ? "Edit" : "Plus"} />
      {account?.account_type == "FARM" || formik.values.account_type == "FARM" ? "Farm" : formik.values.account_type != '-1' ? "Sub Account" : "Account"} {account?.id ? "Edit" : "Add"}
      {/* {account?.id  ? "Edit" : "Add"} {formik.values.account_type == "SUB_ENTITY" ? "Sub Account" : "Farm"} */}
    </div>
  );


  return (
    <CustomDialog open={open} onClose={onClose} width={640} title={title}>
      <FormikProvider value={formik}>
        <Form className={css.modalForm}>

          {!account?.id && canAddSubEntity &&

            <div>


              <CustomSelect
                label="Account Type"
                labelShrink={false}
                name="account_type"
                options={[{ id: "-1", value: "-1", name: 'Select Account Type', disabled: true }, ...account_types]}
                value={formik.values.account_type}
                onChange={formik.handleChange}
                halfWidth

              />

              <ErrorMessage
                name="account_type"
                render={msg => <div style={{ color: '#d32f2f', font: '400 12px/18px var(--font-inter)', margin: 0 }}>{msg}</div>}
              />


            </div>
          }


          <FormikTextField
            label={`${formik.values.account_type == "SUB_ENTITY" ? "Sub Account" : "Farm"} Name*`}
            labelShrink={true}
            name="name"
            type="text"
          />

          <FormikTextField
            label="Rewards ID"
            labelShrink={true}
            name="rewards_code"
            type="text"
          />
          <div className={css.actions}>
            <CustomButton
              label="Cancel"
              onClick={onClose}
              color="secondary"
            />

            <CustomButton
              label="Save"
              type="submit"
              color="primary"
              onSubmit={formik.handleSubmit}
            />
          </div>
        </Form>
      </FormikProvider>
    </CustomDialog>
  );
};

export default ModalFarmOrSubEnt;
